import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  inject,
  input,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { NavigationService, RoleMenuItem } from "./navigation.service";
import { User } from "../../user/user.model";
import { NotifyService } from "../../notify/notify.service";
import { Router, RouterLink, RouterLinkActive } from "@angular/router";

@Component({
  selector: "app-nav",
  templateUrl: "./nav.component.html",
  styleUrls: ["./nav.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, RouterLinkActive],
})
export class NavComponent implements OnInit, OnDestroy {
  private navigationService = inject(NavigationService);
  private notifyService = inject(NotifyService);
  private router = inject(Router);

  @Input() public user: User;
  public readonly opened = input<boolean>(undefined);
  public navigationItems: RoleMenuItem[] = [];
  private subscription = new Subscription();

  ngOnInit() {
    this.buildNavigation();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener("document: mousedown", ["$event"]) onMouseDown(event) {
    if (event && event.path) {
      for (const elem of event.path) {
        // class="toggle-submenu submenu-{{ index }}"
        if (elem.classList && elem.classList.contains("toggle-submenu")) {
          this.toggleSubmenu(elem.classList[1].split("-")[1]);
        }
      }
    }
  }

  public buildNavigation() {
    this.subscription.add(
      this.navigationService.getItems().subscribe((navigation) => {
        navigation.map((category, catIdx) => {
          category = this.navigationService.getItemWithClassesUpdatedByUserRole(
            this.user,
            category,
          );
          navigation[catIdx].visible = this.navigationService.setVisibleIfRole(
            this.user,
            category,
          );

          if (category.items) {
            category.items.map((categoryItem, itmIdx) => {
              categoryItem =
                this.navigationService.getItemWithClassesUpdatedByUserRole(
                  this.user,
                  categoryItem,
                );
              navigation[catIdx].items[itmIdx].visible =
                this.navigationService.setVisibleIfRole(
                  this.user,
                  categoryItem,
                );
            });
          }
        });

        this.navigationItems = navigation;
      }),
    );
  }

  public toggleSubmenu(index: number): void {
    if (!this.navigationItems || this.navigationItems[index] === undefined) {
      return;
    }

    this.navigationItems[index].expanded =
      !this.navigationItems[index].expanded;
  }

  public getVisibleItemsCount(menuItems: RoleMenuItem[]): number {
    if (menuItems) {
      return menuItems.filter((item) => item.visible).length;
    }
  }

  public callMethod(method: string): void {
    if (this[method]) {
      this[method]();
    }
  }

  public isLinkNotActive(link: RoleMenuItem): boolean {
    return link.module && this.user.getModules()?.indexOf(link.module) === -1;
  }

  public isCallbackActive(link: RoleMenuItem): boolean {
    const orgId = this.user?.getTeam()?.getOrganization()?.getId();
    if (!orgId) {
      return false;
    }

    const url = this.router.url;
    const orgBase = `/organization/${orgId}`;
    const termsBase = `${orgBase}/terms`;
    const isUnderOrg = url === orgBase || url.startsWith(`${orgBase}/`);
    const isUnderTerms = url === termsBase || url.startsWith(`${termsBase}/`);

    switch (link.callback) {
      case "openOrganizationTermsList":
        return isUnderTerms;
      case "openOrganizationForm":
        return isUnderOrg && !isUnderTerms;
      default:
        return false;
    }
  }

  public openOrganizationForm() {
    const orgId = this.user.getTeam().getOrganization().getId();
    this.router.navigate([`organization/${orgId}`]);
  }

  public openOrganizationTermsList() {
    const orgId = this.user.getTeam().getOrganization().getId();
    this.router.navigate([`organization/${orgId}/terms/list`]);
  }
}
